import React from "react";
import "./App.css";
import { apps } from "./desktop/appsRegistry";
import { WindowManagerProvider } from "./desktop/WindowManager";
import Desktop from "./desktop/Desktop";
import PhoneShell from "./desktop/mobile/PhoneShell";
import { useIsMobile } from "./desktop/useIsMobile";

function App() {
  const isMobile = useIsMobile();

  return (
    <WindowManagerProvider registry={apps} bootEnabled={!isMobile}>
      {isMobile ? <PhoneShell /> : <Desktop />}
    </WindowManagerProvider>
  );
}

export default App;
